import React from "react";

export function MiniGrantAwardees() {
  return (
    <div className="fqxi-shortcodes-miniGrantAwardees"></div>
  );
}
